import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { selectCaptchaEnabled, selectTurnstileSiteKey } from '../../global-selectors';
import { useTurnstile } from '../../utils/hooks/useTurnstile';
import { TurnstileCaptcha } from '../../components/form/CaptchaTurnstile';

const withAutoCaptchaLogic = (WrappedComponent) => {
  const WithAutoCaptchaComponent = ({ siteKey, isCaptchaEnabled, ...props }) => {
    const {
      token,
      execute,
      reset,
      handleVerify,
      handleExpire,
      turnstileRef
    } = useTurnstile();

    useEffect(() => {
      if (props.code && isCaptchaEnabled && !token) {
        execute();
      }
    }, [props.code, isCaptchaEnabled]);

    return (
      <>
        <WrappedComponent
          {...props}
          {...(isCaptchaEnabled && { captchaToken: token })}
          executeCaptcha={execute}
          resetCaptcha={reset}
          isCaptchaEnabled={isCaptchaEnabled}
        />
        {isCaptchaEnabled && props.code && (
          <div style={{ position: 'absolute', left: '-9999px', visibility: 'hidden' }}>
            <TurnstileCaptcha
              ref={turnstileRef}
              sitekey={siteKey}
              size="flexible"
              appearance="execute"
              theme="dark"
              onVerify={handleVerify}
              onExpire={handleExpire}
            />
          </div>
        )}
      </>
    );
  };

  return WithAutoCaptchaComponent;
};

const mapStateToProps = (state) => ({
  siteKey: selectTurnstileSiteKey(state),
  isCaptchaEnabled: selectCaptchaEnabled(state)
});

export default compose(connect(mapStateToProps), withAutoCaptchaLogic);